<template>
    <div class="recharge">
        <div class="title">充值</div>
        <ul class="recharge-list">
            <li v-for="item in list" :key="item.value" class="item" :class="item.value==active?'active':''" @click="handleSelect(item.value)">
                <img :src="img" alt="">
                <div class="item-left">
                    <div class="item-left-top">
                        <span class="item-diamond">{{item.diamond1 + item.diamond2}}</span>
                        <span class="item-price">￥{{item.price}}</span>
                    </div>
                    <div class="item-text">{{item.diamond1}}钻石，额外赠送{{item.diamond2}}钻石</div>
                </div>
            </li>
        </ul>
        <div class="recharge-btn">
            <div class="recharge-btn-text" @click="handlePay">微信支付</div>
        </div>
        <div class="recharge-warn">
            <div class="recharge-warn-tip"><i class="el-icon-info"></i>温馨提示：</div>
            <p>1.如遇到任务充值问题，可联系游戏内客服在线咨询</p>
            <p>2.本界面显示钻石非实时刷新，充值后请重新登录游戏哦。</p>
        </div>
        <div class="recharge-info">
            适龄提醒：本游戏适合12周岁以上者参与<br>
            抵制不良游戏，拒绝盗版游戏，注意自我保护，谨防上当受骗。<br>
            适当游戏益脑，沉迷游戏伤身，合理安排时间，享受健康生活。<br>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            img:require('@/common/imgs/diamond.png'),
            list:[
                { diamond1: 60, diamond2: 60, price: 6, value: 1 },
                { diamond1: 300, diamond2: 700, price: 30, value: 2 },
                { diamond1: 680, diamond2: 1720, price: 68, value: 3 },
                { diamond1: 1280, diamond2: 3720, price: 128, value: 4 },
                { diamond1: 3280, diamond2: 9720, price: 328, value: 5 },
                { diamond1: 6480, diamond2: 21520, price: 648, value: 6 }
            ],
            active:0
        }
    },
    methods:{
        handleSelect(value){
            this.active = value;
        },
        handlePay(){
            this.$message('支付中');
        }
    }
}
</script>
<style src='./css/recharge.css'></style>